import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";

export const $ProductDetailModuleName = "productDetail";

export type TProductDetailState = {
    deliveryType: DeliveryType;
    storeCode: string | null;
    quantity: number;
    sku: string;
    stickyOrderButton: boolean;
    serviceProductSkus?: string[];
};
